import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/supply/lists/')({
  component: () => <Navigate to="/supply/lists/all" search={{}} replace />,
});
